module.exports = __webpack_public_path__ + "img/unknown-country.8b130a21.svg";